import { Component } from '@angular/core';
import { OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ComponentBase } from '../../../../core/_infrastructure/classes/componentBase';
import { ExceptionManager } from '../../../../core/_infrastructure/classes/handlers/exceptionManager';
import { AuthService } from '../../../../core/_infrastructure/classes/services/auth.service';
import { GlobalService } from '../../../../core/_infrastructure/classes/services/global.service';
import { NotificationService } from '../../../../core/_infrastructure/classes/services/notification.service';
import { FilterSearchingBaseViewModel, Tc } from '../../../../core/_infrastructure/types/common';
import { TratamientoDesinfeccionService } from '../tratamientodesinfeccion.service';
import { FilterSearchingTTratamientoCamViewModel, TratamientoDesinfeccionItemResultsViewModel } from '../tratamientodesinfeccion.types';

@Component({
    selector: 'app-tratamientodesisfeccion-wrapper',
    templateUrl: './tratamientodesinfeccion-wrapper.component.html',
})
export class TratamientoDesinfeccionWrapperComponent extends ComponentBase implements OnInit {
    visibilitySpinner = false;
    searching = false;
    result: TratamientoDesinfeccionItemResultsViewModel | null;
    payload?: FilterSearchingTTratamientoCamViewModel;
    edition = false;
    paises: Tc[];
    campanias: Tc[];

    constructor(
        protected notificacionService: NotificationService,
        protected authService: AuthService,
        protected exceptionHandler: ExceptionManager,
        private globalService: GlobalService,
        private tratamientodesinfeccionService: TratamientoDesinfeccionService,
        private router: Router,
    ) {
        super(authService, notificacionService, exceptionHandler);
    }

    ngOnInit(): void {
        this.recoverLastSearch();
        this.getCampanias();
        this.getPaises();
    }
    private getCampanias(): void {
        this.globalService.getAllCampanias().subscribe((campanias: Tc[]) => {
            this.campanias = campanias;
        });
    }
    private getPaises(): void {
        this.globalService.getAllPaises().subscribe((paises: Tc[]) => {
            this.paises = paises;
        });
    }

    onSearch(payload: FilterSearchingTTratamientoCamViewModel): void {
        if (!payload) {
            return;
        }

        this.payload = { ...payload } as FilterSearchingTTratamientoCamViewModel; // To keep a copy to be used in the lazy search (paginator)

        this.tratamientodesinfeccionService.getTratamientosDesinfeccion(payload).subscribe(results => {
            this.result = results;
            this.searching = true;
        });
    }

    onSearchLazy(lazyLoadParams: FilterSearchingBaseViewModel): void {
        const payload = {
            ...this.payload,
            PageNumber: lazyLoadParams.PageNumber,
            Asc: lazyLoadParams.Asc,
            OrderBy: lazyLoadParams.OrderBy,
        } as FilterSearchingTTratamientoCamViewModel;
        this.onSearch(payload);
    }

    onReset(): void {
        this.searching = false;
        this.result = null;
        this.tratamientodesinfeccionService.clearLastSearch();
    }

    onAdd(): void {
        this.edition = true;
        this.router.navigate(['/mantenimiento/general/tratamientodesinfeccion/create']);
    }

    onEdit(itemId: number | null): void {
        this.edition = true;
        this.router.navigate(['/mantenimiento/general/tratamientodesinfeccion/edit', itemId]);
    }

    private recoverLastSearch() {
        this.payload = this.tratamientodesinfeccionService.getLastSearch();
    }

    onClone(itemId: number): void {
        this.tratamientodesinfeccionService.getCloneTratamientoDesinfeccion(itemId).subscribe(idTratamientoDesinfeccion => {
            if (idTratamientoDesinfeccion != null) {
                this.addSuccessMessage('Tratamiento Desinfección clonado correctamente');
                this.router.navigate(['/mantenimiento/general/tratamientodesinfeccion/edit', idTratamientoDesinfeccion]);
            } else {
                this.addErrorMessage('Error al clonar el Tratamiento ');
            }
        });
    }
}
